import context from './context';

export default (entity, name) => {
  const ctx = context.get(entity, name);
  if (ctx) {
    ctx.abort();
  }
};
